// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7074634a","840":"60e2598b"}[chunkId] + ".chunk.js";
};